export default "__VITE_ASSET__055a7f12__"